import React, { Component } from "react";

import { CCol, CRow, CCollapse } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import ImgNoData from "../../../assets/imgs/graduation.svg";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import EvaluationStatistics from "../../../pages/Activity/Trail/Activity/evaluationStatistics";
import Statistics from "../../../pages/Activity/Trail/Activity/statistics";
import { baseDate } from "../../../utils/date";
import { caminhoDoLo } from "../../../utils/loSingleView";
import TextCreator from "../../Content/TextCreator";
import CorrectLiterarte from "../../CorrectLiterarte";
import Interface from "../../Interface";
import LiterarteModal from "../../LiterarteModal";
import Loading from "../../Loading";
import ModalTools from "../../ModalTools";
import ShareModal from "../../ShareModal";
import Students from "../../Students/Students";
import UploadModal from "../../UploadModal";
import Widgets from "../../Widgets/Widgets";

import "../../../scss/style2.scss";

const FileDownload = require("js-file-download");

class StudentDo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      studentsList: [],
      activity: null,
      activity_id: this.props.match.params.id,
      allocation_id: this.props.match.params.allocation_id,
      loading: true,
      iframe: false,
      leftCollapse: true,
      rightCollapse: true,
      listQuestion: {
        id: "",
        show: false,
        average: 0
      },
      textProduction: {
        id: "",
        show: false,
        value: [
          {
            type: "paragraph",
            children: [{ text: "" }]
          }
        ]
      },
      correctLiterarte: {
        id: "",
        show: false
      },
      contentId: "",
      contentName: "",
      totalActivityItems: 0,
      uploadModal: false,
      modalTool: false,
      toolName: null,
      toolId: null,
      evaluationStatisticsModal: false,
      statisticsModal: false,
      shareModal: false,
      item_id: null,
      literarteStart: null,
      url: null,
      start: null,
      end: null,
      evaluationIdJson: null,
      currentTry: null
    };

    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  createExecution(callback = () => null) {
    const obj = {
      activity_id: this.props.match.params.id
    };

    axios
      .post(`${URL.api}activity/execution/insert`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          this.props.wasOpened(resp.data.data, this.props.match.params.id);
          this.setState({ execution_id: resp.data.data }, () => callback());
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      });
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleActivity(() => this.initializeActivity());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.setState({ loading: true });
      // this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
      this.handleActivity(() => this.initializeActivity());
    }
  }

  handleActivity(callback = () => null) {
    this.props.handleIsLoadingSingleViewByExecution(true);
    if ([7, 8, 9].includes(this.props.general.active_roles.role_id)) {
      this.createExecution(() => {
        axios
          .get(
            `${URL.api}activity/activity/singleViewByExecution/${this.state.execution_id}`,
            {
              headers: {
                authorization: `Bearer ${this.props.user.token}`,
                "Access-Control-Allow-Origin": "*"
              }
            }
          )
          .then(resp => {
            if (resp.data.success) {
              const activity = {
                ...resp.data.data,
                items: resp.data.data.items.map(item => ({
                  ...item,
                  title: item.name,
                  subtitle: item.type_name
                }))
              };
              const evaluationIdJson = resp.data.data.evaluation_id_json;
              if (this.props.source) {
                const currentTry = resp.data.data.last_application?.try
                  ? resp.data.data.last_application?.try
                  : 0;
                this.setState({ currentTry });
              }

              this.setState(
                { evaluationIdJson, activity, itens: activity.items },
                () => {
                  this.props.setLoadingNavigationStep(false);
                  callback();
                }
              );
            } else {
              this.error("Falha ao encontrar a atividade!");
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              this.error("Sua sessão expirou!");
              this.props.logout();
            } else {
              this.error("Falha ao encontrar a atividade!");
            }
          })
          .finally(() => {
            this.props.handleIsLoadingSingleViewByExecution(false);
          });
      });
    } else {
      axios
        .get(
          `${URL.api}activity/activity/singleView/${this.props.match.params.id}`,
          {
            headers: {
              authorization: `Bearer ${this.props.user.token}`,
              "Access-Control-Allow-Origin": "*"
            }
          }
        )
        .then(resp => {
          if (resp.data.success) {
            const activity = {
              ...resp.data.data,
              items: resp.data.data.items.map(item => ({
                ...item,
                title: item.name,
                subtitle: item.type_name
              }))
            };

            this.setState(
              {
                activity,
                itens: activity.items
              },
              () => {
                callback();
              }
            );
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.error("Sua sessão expirou!");
            this.props.logout();
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        })
        .finally(() => {
          this.props.handleIsLoadingSingleViewByExecution(false);
        });
    }
  }

  initializeActivity() {
    let resp = {
      data: this.props.respTrailAllocationSingleView
    };

    const user = {
      id: this.props.user.user.id,
      name: this.props.user.user.username
    };

    const trailActivity = resp.data?.data?.trail?.trail_activities?.find(
      trailActivity =>
        trailActivity.activity_id === parseInt(this.props.match.params.id)
    );

    const executions = trailActivity?.activity?.executions || [];

    const studentsList = (
      resp.data?.data?.users?.length > 0
        ? resp.data.data.users
        : resp?.data?.data?.room?.users?.filter(item => !item.administrator) ||
          []
    ).map(item => ({
      id: item.user?.id,
      name: item.user?.name,
      online: "desconectado",
      color: "primary",
      activity: "",
      profileImage:
        URL.img + (item.user?.photo || "uploads/users/profileEmpty.jpg"),
      role_id: 7,
      execution_items:
        executions
          .find(execution => execution.user_id === item.user?.id)
          ?.items?.map(executionItem => ({
            ...executionItem,
            user_id: item.user?.id
          })) || [],
      items: this.state.itens.length
    }));

    const listQuestion = {
      id: "",
      show: false,
      average: 0
    };

    const activity = {
      // eslint-disable-next-line react/no-access-state-in-setstate
      ...this.state.activity,
      // eslint-disable-next-line react/no-access-state-in-setstate
      items: this.state.activity.items.map(item => ({
        ...item,
        title: item.name,
        subtitle: item.type_name
      }))
    };

    this.setState({
      loading: false,
      activity,
      activity_id: activity.id,
      listQuestion,
      totalActivityItems: activity.items.length,
      studentsList,
      itens: activity.items,
      start: trailActivity?.start,
      end: trailActivity?.end
    });
  }

  closeLeft() {
    document.getElementById("leftSide").style.display = "none";
    document.getElementById("closeLeft").style.display = "none";
    document.getElementById("openLeft").style.display = "block";
  }

  openLeft() {
    document.getElementById("leftSide").style.display = "block";
    document.getElementById("closeLeft").style.display = "block";
    document.getElementById("openLeft").style.display = "none";
  }

  closeRight() {
    document.getElementById("rightSide").style.display = "none";
    document.getElementById("closeRight").style.display = "none";
    document.getElementById("openRight").style.display = "block";
  }

  openRight() {
    document.getElementById("rightSide").style.display = "block";
    document.getElementById("closeRight").style.display = "block";
    document.getElementById("openRight").style.display = "none";
  }

  createItemExecution(item, finished, callback = () => null) {
    const late = this.state.end && Date.parse(this.state.end) < Date.now();

    if (finished || late) {
      callback();
      return;
    }

    const obj = {
      execution_id: this.state.execution_id,
      item_id: item,
      completion_percentage: 100,
      start: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60 * 1000
      ).toISOString(),
      end: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60 * 1000
      ).toISOString()
    };

    axios
      .post(`${URL.api}activity/execution/item/insert`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          this.props.wasOpened(this.state.execution_id, this.state.activity_id);
          callback();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      });
  }

  openItem = item => {
    const late = this.state.end && Date.parse(this.state.end) < Date.now();

    const tryCreateItemExecution = () => {
      if (
        item.id &&
        [7, 8, 9].includes(this.props.general.active_roles.role_id)
      ) {
        this.createItemExecution(item.id, item.item_percentage === 100, () =>
          this.handleActivity()
        );
      }
    };
    if (item.type_id === 12) {
      if (this.props.source) {
        if (this.state.currentTry < 3) {
          const tokenUser = this.props.user.token;

          window.location.href = `http://avaliacao.educandus.com.br:3000/external_auth?token=${tokenUser}
            &evaluationIdJson=${this.state.evaluationIdJson}
            &listId=${item.obj_id}
            &allocationId=${this.props.match.params.allocation_id}
            &try=${this.state.currentTry}
            &source=${this.props.source}
            `;

          // window.location.href = `http://avaliacao.educandus.com.br:3000/external_auth?token=${tokenUser}
          //     &evaluationIdJson=${this.state.evaluationIdJson}
          //     &listId=${item.obj_id}
          //     &allocationId=${this.props.match.params.allocation_id}
          //     &try=${this.state.currentTry}
          //     &source=${this.props.source}
          //     `;
        } else {
          toastr.error("Atenção", "Número total de tentativas excedido!");
        }
      } else {
        window.open(
          `/questionlist/do/${this.props.match.params.id}?itemid=${item.id}&listid=${item.obj_id}`,
          "_blank"
        );
      }
    } else if (item.type_id === 33) {
      this.setState({ lo_id: item.obj_id, textModal: true });
      tryCreateItemExecution();
    } else if (item.type_id === 15) {
      // NEWTON
      this.setState({
        modalTool: true,
        toolId: item.type_id,
        toolName: item.title,
        item_id: item.id
      });

      tryCreateItemExecution();
    } else if (item.type_id === 16 || item.type_id === 27) {
      // LINK
      axios
        .get(`${URL.api}content/los/singleView/${item.obj_id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            window.open(caminhoDoLo(resp), "_blank");

            tryCreateItemExecution();
          },
          () => {
            toastr.error(
              "Falha",
              "Não foi possível abrir o link. Tente novamente!"
            );
          }
        );
    } else if (item.type_id === 14) {
      // LITERARTE
      if (late && item.item_percentage !== 100) {
        toastr.warning("Atenção", "A atividade já foi encerrada!");
        return;
      }

      this.setState({
        textProduction: {
          // eslint-disable-next-line react/no-access-state-in-setstate
          ...this.state.textProduction,
          show: true,
          id: item.obj_id
        },
        item_id: item.id,
        contentName: item.title,
        literarteStart: new Date()
      });
    } else if (item.type_id === 18) {
      // Upload

      if (item.item_percentage === 100) {
        toastr.info(
          "Item realizado",
          item.item_grade
            ? `Você tirou a nota ${item.item_grade}`
            : "A correção ainda não está disponível"
        );
      } else {
        this.setState({
          uploadModal: true,
          contentId: item.obj_id,
          contentName: item.title,
          item_id: item.id
        });
      }
    } else if (item.type_id !== 17) {
      window.open(`/content/view/${item.obj_id}?title=${item.title}`, "_blank");
      tryCreateItemExecution();
    } else {
      const downloadPath = item.link
        ? item.link.substring(item.link.indexOf("uploads/") + 8)
        : `${item.obj_id === 1 ? "activity" : "repo"}/${item.name}`;

      axios
        .get(`${URL.api}download/${downloadPath}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          responseType: "blob"
        })
        .then(resp => {
          FileDownload(resp.data, item.name);

          tryCreateItemExecution();
        });
    }
  };

  saveTextProduction = pages => {
    let pagesObj = [];
    for (let i = 0; i < pages.length; i++) {
      pagesObj.push({
        number: i,
        content: JSON.stringify(pages[i])
      });
    }

    let obj = {
      user_id: this.props.user.user.id,
      literarte_activity_id: this.state.textProduction.id,
      pages: pagesObj,
      item_id: this.state.item_id,
      execution_id: this.state.execution_id,
      start: baseDate(this.state.literarteStart),
      end: baseDate(new Date())
    };

    axios
      .post(`${URL.api}literarte/production_create`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          toastr.success("Sucesso", "O texto foi salvo.");
          this.setState({
            textProduction: {
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.textProduction,
              show: false
            }
          });
        }
      });
  };

  render() {
    const late =
      !this.state.loading &&
      this.state.end &&
      Date.parse(this.state.end) < Date.now();

    return (
      <React.Fragment>
        {this.state.iframe && (
          <Interface
            show={this.state.iframe}
            title={this.state.contentName}
            onClose={() =>
              this.setState({ iframe: false }, () => this.handleActivity())
            }
            aula={this.state.contentId}
            atividade={this.props.match.params.id}
            act_item_id={this.state.item_id}
            act_execution_id={late ? undefined : this.state.execution_id}
            currentRoute={this.props.currentRoute}
            url={!this.state.contentId && this.state.url}
          />
        )}
        <ModalTools
          show={this.state.modalTool}
          tool={this.state.toolId}
          title={this.state.toolName}
          onClose={() =>
            this.setState({ modalTool: false }, () => this.handleActivity())
          }
          activity={this.props.match.params.id}
          students={this.state.studentsList}
          currentRoute={this.props.currentRoute}
        />
        <EvaluationStatistics
          show={this.state.evaluationStatisticsModal}
          onClose={() => this.setState({ evaluationStatisticsModal: false })}
          allocation_id={this.state.allocation_id}
          activity={this.props.match.params.id}
          currentRoute={this.props.currentRoute}
        />
        <Statistics
          show={this.state.statisticsModal}
          onClose={() => this.setState({ statisticsModal: false })}
          allocation_id={this.state.allocation_id}
          activity={this.props.match.params.id}
          currentRoute={this.props.currentRoute}
        />
        <ShareModal
          show={this.state.shareModal}
          onClose={() => this.setState({ shareModal: false })}
          link={window.location.href}
        />
        {this.state.uploadModal && (
          <UploadModal
            onClose={() =>
              this.setState({ uploadModal: false }, () => this.handleActivity())
            }
            upload_id={this.state.contentId}
            activity_id={this.props.match.params.id}
            item_id={this.state.item_id}
            execution_id={this.state.execution_id}
          />
        )}
        {this.state.textProduction.id !== "" ? (
          <LiterarteModal
            id={this.state.textProduction.id}
            user_id={this.props.user.user.id}
            show={this.state.textProduction.show}
            onClose={() =>
              this.setState(
                {
                  textProduction: {
                    // eslint-disable-next-line react/no-access-state-in-setstate
                    ...this.state.textProduction,
                    show: false
                  }
                },
                () => this.handleActivity()
              )
            }
            title={this.state.contentName}
            value={this.state.textProduction.value}
            onChange={value =>
              this.setState({
                textProduction: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.textProduction,
                  value
                }
              })
            }
            saveTextProduction={pages => this.saveTextProduction(pages)}
          />
        ) : null}
        {this.state.correctLiterarte && (
          <CorrectLiterarte
            id={this.state.correctLiterarte.id}
            show={this.state.correctLiterarte.show}
            onClose={() =>
              this.setState({
                correctLiterarte: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.correctLiterarte,
                  show: false
                }
              })
            }
            user_id={this.props.user.user.id}
          />
        )}
        {this.state.textModal && (
          <TextCreator
            show={this.state.textModal}
            onClose={() =>
              this.setState({
                textModal: false
                // currentLOLink: null
              })
            }
            // eslint-disable-next-line react/jsx-boolean-value
            showOnly={true}
            currentLOLink={this.state.lo_id}
          />
        )}
        {!this.state.loading ? (
          <>
            {![7, 8, 9].includes(this.props.general.active_roles.role_id) ? (
              <React.Fragment>
                <CRow className="flex-1 d-none">
                  <CCol xs="12" md="6">
                    <div className="pt-3 d-flex align-items-center justify-content-between">
                      <h4 className="m-0">Itens</h4>
                      <i
                        onClick={() =>
                          this.setState(state => ({
                            leftCollapse: !state.leftCollapse
                          }))
                        }
                        className={`text-muted activity-collapse fa fa-chevron-${
                          this.state.leftCollapse ? "up" : "down"
                        }`}
                      ></i>
                    </div>
                    <hr
                      style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }}
                    />
                    <CCollapse show={this.state.leftCollapse}>
                      <Widgets
                        itens={this.state.itens}
                        openItem={this.openItem}
                        closeItem={this.closeItem}
                        teacher
                        onEvaluationStatistics={id =>
                          this.setState({ evaluationStatisticsModal: false })
                        }
                      />
                    </CCollapse>
                  </CCol>
                  <CCol xs="12" md="6">
                    <div className="pt-3 d-flex align-items-center justify-content-between">
                      <h4 className="m-0">Usuários</h4>
                      <i
                        onClick={() =>
                          this.setState(state => ({
                            rightCollapse: !state.rightCollapse
                          }))
                        }
                        className={`text-muted activity-collapse fa fa-chevron-${
                          this.state.rightCollapse ? "up" : "down"
                        }`}
                      ></i>
                    </div>
                    <hr
                      style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }}
                    />
                    <CCollapse show={this.state.rightCollapse}>
                      <Students
                        studentsList={this.state.studentsList}
                        listQuestion={this.state.listQuestion}
                        totalActivityItems={this.state.totalActivityItems}
                        activityItems={this.state.itens}
                        isTrailActivity
                      />
                    </CCollapse>
                  </CCol>
                </CRow>
              </React.Fragment>
            ) : (
              <>
                {this.state.start && new Date(this.state.start) > new Date() ? (
                  <CRow className="flex-1">
                    <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
                      <img
                        src={ImgNoData}
                        style={{ height: "240px", marginBottom: "2rem" }}
                        alt=""
                      />
                      <p
                        style={{ fontSize: "1.5rem" }}
                        className="mb-2 font-weight-bold text-center"
                      >
                        A atividade ainda não foi liberada
                      </p>
                      <span className="text-muted text-center">
                        Tente voltar daqui a alguns minutos
                      </span>
                    </div>
                  </CRow>
                ) : (
                  <CRow className="flex-1">
                    {this.state.itens.length > 0 && (
                      <CCol lg="12">
                        <div id="leftSide">
                          <Widgets
                            itens={this.state.itens}
                            openItem={this.openItem}
                            completionMark
                            source={this.props.source}
                            currentTry={this.state.currentTry}
                          />
                        </div>
                      </CCol>
                    )}
                  </CRow>
                )}
              </>
            )}
          </>
        ) : (
          <div className="flex-1 justify-content-center align-items-center">
            <Loading top="45" left="50" />
          </div>
        )}
      </React.Fragment>
    );
  }
}

StudentDo.defaultProps = {
  hideLayout: false,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentDo);
